import { Seo } from "../components/site/Seo";
import { ArcButton } from "../components/site/Brand";
import { MaskLines } from "../lib/motion";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Arc & Hollow" description="The page you are looking for could not be found." path="/404" />
      <section className="min-h-[80svh] container-x flex flex-col justify-center py-40" data-testid="not-found">
        <p className="overline text-bronze mb-8">Error 404</p>
        <h1 className="font-serif font-light text-6xl sm:text-7xl lg:text-8xl leading-none tracking-tight">
          <MaskLines lines={["This page is", "beyond the plan."]} />
        </h1>
        <p className="mt-10 max-w-xl text-lg font-light leading-relaxed text-olive">
          The page you were looking for cannot be found. It may have moved, or the address may be incomplete.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <ArcButton to="/" variant="primary">Return home</ArcButton>
          <ArcButton to="/projects" variant="outline">View projects</ArcButton>
        </div>
      </section>
    </>
  );
}
